<p-confirmDialog
  #confirmation
  [style]="{ width: '30rem' }">
  <ng-template #footer>
    <div class="grid w-full grid-cols-2 gap-3">
      <div>
        <p-button
          (onClick)="accept()"
          [autofocus]="true"
          [fluid]="true"
          [label]="acceptLabel"
          appPrimengButton
          severity="primary"
          type="button" />
      </div>

      <div>
        <p-button
          (onClick)="reject()"
          [fluid]="true"
          [label]="rejectLabel"
          appPrimengButton
          type="button"
          variant="outlined" />
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
